import mapValues from 'lodash/mapValues';
import groupBy from 'lodash/groupBy';
import omit from 'lodash/omit';
import { reportError } from 'utils/sentry.utils';

type Node<T> = T & { children: Node<T>[] };

export const populateProjectsChildren = <T extends { id: string; parentProjectId?: string }>(
  projects: Record<string, T>
): Record<string, Node<T>> => {
  const result = mapValues(projects, project => ({
    ...project,
    children: []
  })) as Record<string, Node<T>>;

  const missingParents = [];

  const projectByParent = groupBy(result, 'parentProjectId');
  const nonRootProjectsByParent: Record<string, Node<T>[]> = omit(projectByParent, 'undefined');

  for (const [parentId, children] of Object.entries(nonRootProjectsByParent)) {
    const parent = result[parentId];
    if (parent) {
      parent.children = children;
    } else {
      missingParents.push({ parentId, children: children.map(p => p.id) });
    }
  }

  if (missingParents.length > 0) {
    const error = new Error(`Error building projects tree. Missing parent projects.`);
    reportError('use-projects', error, { missingParents });
  }

  return result;
};
